// Which tools each mount of the shared tool pages offers. Khatabook belongs to Customers and Cashbook to
// Partners; Project Ledger and Lease Management stay where they were.
const ALL_TOOLS = ["khatabook", "cashbook", "projects", "leases"];

export const TOOLS_BY_BASE = {
  "/partner/tools": ["cashbook", "projects", "leases"],
  "/customer/tools": ["khatabook", "projects", "leases"],
  "/admin/tools": ALL_TOOLS,
  "/tools": ["projects", "leases"],
};

/** Base path of the tools mount a pathname belongs to (partner, customer, admin or standalone). */
export const resolveToolsBase = (pathname, fallback = "/partner/tools") => {
  if (pathname.startsWith("/partner/")) return "/partner/tools";
  if (pathname.startsWith("/customer/")) return "/customer/tools";
  if (pathname.startsWith("/admin/")) return "/admin/tools";
  if (pathname.startsWith("/tools")) return "/tools";
  return fallback;
};

export const isToolAvailable = (base, toolId) => (TOOLS_BY_BASE[base] || ALL_TOOLS).includes(toolId);
